// ─────────────────────────────────────────────────────────────────
// Sehat AI — Central Configuration
// All keys pulled from .env file (never hardcode secrets here)
// ─────────────────────────────────────────────────────────────────

const config = {
  // API Keys
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || '',
  ANTHROPIC_API_KEY: process.env.REACT_APP_ANTHROPIC_API_KEY || '',

  // App settings
  APP_NAME: 'Sehat AI',
  VERSION: '1.0.0',
  DEFAULT_CITY: 'Jaipur',
  DEFAULT_LAT: 26.9124,
  DEFAULT_LNG: 75.7873,
  DEFAULT_RADIUS: 5000, // metres for Places search

  // Claude model
  CLAUDE_MODEL: 'claude-sonnet-4-6',
  CLAUDE_MAX_TOKENS: 1000,

  // ElevenLabs TTS — voice ID comes from .env (Tripti or any other voice)
  ELEVENLABS_VOICE_ID: process.env.REACT_APP_ELEVENLABS_VOICE_ID || '',

  // CORS proxy for Google Places (browser-side)
  CORS_PROXY: 'https://corsproxy.io/?',

  // Demo mode if no keys provided
  get isDemoMode() {
    return !this.GOOGLE_API_KEY || this.GOOGLE_API_KEY === 'YOUR_GOOGLE_PLACES_API_KEY';
  },
};

export default config;
